import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";

export class DCRoadNormalIdlePresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        DevilsCrossRoad.reels.setIdle();
        DevilsCrossRoad.devil.playIdle();
        if(DevilsCrossRoad.model.data.nextMode === GameMode.NORMAL && !DevilsCrossRoad.autoPlayPlugin.isAutoplayRound) {
            DevilsCrossRoad.idle.start();
        }

        if(!DevilsCrossRoad.model.gameData) {
            // game init idle.
            flowStateController.setSkipCallback(() => this.skip(flowStateController));
            return;
        }

        if(DevilsCrossRoad.model.gameData?.nextMode != GameMode.NORMAL) {
            debugger;
            flowStateController.finish();
            DevilsCrossRoad.idle.start();
            return;
        }

        // if(!BelowStakeWinRestriction.isWinBelowPlayedBetValue() && !TrueKult.autoPlayPlugin.isAutoplayRound) {
        //     TrueKult.individualWin.start();
        //     // TODO: idleAnimation.start();
        // }

        BelowStakeWinRestriction.reset();

        flowStateController.setSkipCallback(() => this.skip(flowStateController));
    }

    private skip(flowStateController:FlowStateController):void {
        flowStateController.finish();
    }
}